import React from "react";
import PropTypes from "prop-types";
import NewNote from "./CreateNote/NewNote";

export default function HeaderMinor(props) {
  return (
    <div>
      <hr className="hr-dashed" />
      <h2>
        Minor Notes
        {props.minor || <NewNote {...props} minor />}
      </h2>
    </div>
  );
}

HeaderMinor.propTypes = {
  minor: PropTypes.bool
};



// WEBPACK FOOTER //
// ./app/modules/shared/components/Notes/HeaderMinor.jsx